import script from "./authLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./authLayout.vue?vue&type=script&setup=true&lang=js"

import "./authLayout.vue?vue&type=style&index=0&id=526ebc92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-526ebc92"]])

export default __exports__